module.exports = __webpack_public_path__ + "img/myclinic-rec-2.cd9cd6de.png";